import { render } from "./docente.vue?vue&type=template&id=25b5718f&scoped=true"
import script from "./docente.vue?vue&type=script&lang=js"
export * from "./docente.vue?vue&type=script&lang=js"

import "./docente.vue?vue&type=style&index=0&id=25b5718f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25b5718f"]])

export default __exports__